import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../feature/users/userSlice";

const UserModals = () => {
  const dispatch = useDispatch();
  const { isViewModalOpen, isDeleteModalOpen, viewSingleUser } = useSelector(
    (state) => state.users
  );

  const ViewUserModal = () => {
    return (
      <Dialog open={isViewModalOpen} onClose={() => dispatch(closeModal())}>
        <DialogTitle> {viewSingleUser.id} </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Name: {viewSingleUser.name}
          </DialogContentText>
          <DialogContentText id='alert-dialog-description'>
            Email: {viewSingleUser.email}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color='secondary'
            onClick={() => dispatch(closeModal())}
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const DeleteConfirmationModal = () => {
    return (
      <Dialog open={isDeleteModalOpen}>
        <DialogTitle>Delete {viewSingleUser.name} </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to delete this User?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color='error'>Delete</Button>
          <Button color='secondary' onClick={() => dispatch(closeModal())}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <>
      <ViewUserModal />
      <DeleteConfirmationModal />
    </>
  );
};

export default UserModals;
